import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Area } from 'recharts';
import './ProfitChart.css';

const data = [
  { name: 'Sun', revenue: 4000 },
  { name: 'Mon', revenue: 3000 },
  { name: 'Tue', revenue: 5000 },
  { name: 'Wed', revenue: 3500 },
  { name: 'Thu', revenue: 2500 },
  { name: 'Fri', revenue: 5000 },
  { name: 'Sat', revenue: 3000 },
];

const ProfitChart = () => {
  return (
    <div className="chart-container">
      <div className="chart-header">

        <div className="chart-metrics">
          <div className="metric">
            <span>Total Revenue</span>
            <strong>$5,456.00</strong>
          </div>
          <div className="metric">
            <span>Total Client</span>
            <strong>350</strong>
          </div>
          <div className="metric">
            <span>Total Revenue</span>
            <strong>$5,456.00</strong>
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} margin={{ top: 20, right: 0, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#14c8ff" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#14c8ff" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" tickLine={false} axisLine={false} />
          <YAxis hide={true} />
          <Tooltip />
          <Bar dataKey="revenue" fill="url(#colorRevenue)" radius={[0, 0, 0, 0]} />
          <Area
            type="monotone"
            dataKey="revenue"
            stroke="#14c8ff"
            fillOpacity={0}
            strokeWidth={2}
            dot={false}
            activeDot={false}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ProfitChart;
